import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17.342 14.813h-6.796a.566.566 0 0 1-.566-.563v-9c0-.31.254-.562.566-.562h4.959l2.403 2.387v7.175c0 .31-.255.563-.566.563M10.546 16.5h6.796a2.26 2.26 0 0 0 2.265-2.25V7.075c0-.447-.18-.876-.499-1.192l-2.4-2.387a1.7 1.7 0 0 0-1.2-.496h-4.962A2.26 2.26 0 0 0 8.28 5.25v9a2.26 2.26 0 0 0 2.265 2.25m-4.53-9A2.26 2.26 0 0 0 3.75 9.75v9A2.26 2.26 0 0 0 6.015 21h6.796a2.26 2.26 0 0 0 2.265-2.25v-1.125h-1.698v1.125c0 .31-.255.563-.567.563H6.015a.566.566 0 0 1-.566-.563v-9c0-.31.255-.562.566-.562h1.133V7.5z"
    }, null, -1)
  ]))]))
}
export default { render: render }